import { AxiosError } from "axios";
import { useMutation } from "react-query";
import ApiError from "types/ApiError";
import { authInstance } from "apis";

interface Props {
  onError: (error?: string | string[]) => void;
}

const useDeleteUserMe = ({ onError }: Props) => {
  const fetcher = async () => {
    const { data } = await authInstance.delete("user/me");
    return data;
  };

  const { mutate } = useMutation(fetcher, {
    onError: (error: AxiosError<ApiError>) => {
      onError(error.response?.data.message);
    },
    onSuccess: () => {
      window.localStorage.removeItem("TOKEN");
      window.location.href = "/login";
    },
  });

  return mutate;
};

export default useDeleteUserMe;
